import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const sandstoneDunesMetadata = {
  id: 'sandstone-dunes',
  name: 'Sandstone Dunes',
  description:
    'An expansive open desert course over pale rolling dunes, where broad corridors, native waste sand and exposed wind reward route selection.',
  environmentPreset: 'sandstone-desert',
  metadata: {
    location: 'Sonoran Desert',
    regionType: 'open sandstone dunes',
    difficulty: 84,
    typicalWind: [6, 18] as const,
    greenSpeed: [10.5, 11.5] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Open desert strategy over pale sand',
    signatureHoles: [2, 6, 14, 18],
    tournamentEventId: 'event-16',
    previewTheme: 'sandstone-desert',
    environmentPalette: {
      fairway: '#9b9b58',
      rough: '#80774b',
      bunker: '#ddb978',
      water: '#4d8990',
      haze: '#deb97e',
      sky: '#7fb4ce',
      rock: '#b58b5c',
      wasteArea: '#cfaa6d',
    },
    vegetationStyle: 'sparse desert scrub and grass',
    terrainStyle: terrainPreset('sandstone-desert', 20, 150, 1.1).id,
    sunlightDirection: 'hard southern desert sun',
    distantScenery: 'open dune fields and distant mesas',
    waterStyle: 'deep mineral-blue desert water',
    eventPresentation: {
      accentColor: '#7fb4ce',
      mark: 'SANDSTONE',
      subtitle: 'Width is a decision',
      loadingCopy: 'Pick a dune corridor and commit',
      identityLine: 'Open desert strategy over pale sand',
      tierLabel: 'STANDARD',
    },
    wasteArea: { carryMultiplier: 0.91, consistencyMultiplier: 0.88, rollMultiplier: 0.72 },
  },
};
const pars = [4, 5, 4, 3, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4, 3, 5, 4, 4];
const yards = [
  440, 610, 420, 190, 455, 330, 215, 585, 450, 430, 180, 575, 445, 410, 205, 560, 435, 460,
];
const names = [
  'Open Sand',
  'Staggered Dunes',
  'Mesa Line',
  'Pale Shelf',
  'Cross Dune',
  'Three Roads',
  'High Sand',
  'Wind Corridor',
  'Broad Turn',
  'Native Edge',
  'Sun Bowl',
  'Firm Route',
  'Long Carry',
  'Dune Choice',
  'Island of Grass',
  'Rolling Home',
  'Last Width',
  'Narrow Crown',
];
const options: Partial<HolePlan>[] = [];
options[1] = {
  splitFairway: true,
  rocks: 2,
  landingZones: [{ distance: 290, width: 64, preferredSide: 'left' }],
};
options[5] = {
  splitFairway: true,
  landingZones: [{ distance: 285, width: 70, preferredSide: 'right' }],
  bunkerCount: 5,
};
options[6] = { elevation: { tee: 0, landing: 8, green: 18 }, bunkerCount: 6 };
options[13] = { splitFairway: true, bunkerCount: 5 };
options[17] = {
  elevation: { tee: 0, landing: 6, green: 20 },
  landingZones: [{ distance: 285, width: 58, preferredSide: 'right' }],
  bunkerCount: 5,
};
export const createSandstoneDunesDocument = () =>
  authorCourse({
    ...sandstoneDunesMetadata,
    plans: plans(names, pars, yards, options).map((plan) => ({
      ...plan,
      trees: plan.trees ?? 1,
      rocks: plan.rocks ?? 0,
    })),
  });
